<template>
  <div style="display: inline-block;">
    <AddProducts :product="product" :copyform="copyform" v-on:add="submit">
      <slot></slot>
    </AddProducts>
  </div>
</template>

<script>
/* eslint-disable eqeqeq */
import AddProducts from '../components/AddProducts'
import api from '../../../services/api.js'

export default {
  name: 'CartAdd',
  props: ['product', 'copyform'],
  components: {
    AddProducts: AddProducts
  },
  computed: {},
  data () {
    return {}
  },
  methods: {
    async submit (form) {
      if (!form.good_id) {
        form.good_id = '0'
      }
      if (form.color || form.size) {
        form.onekey = 1
      }
      if (!this.copyform) {
        let res = await api.post(this, {
          path: 'cart.php',
          api: form.id ? 'update' : 'add',
          data: [form],
          loading: 'loading'
        })
        if (res.body.status == 'ok') {
          if (this.product) {
            this.product = Object.assign(this.product, form)
          }
          this.$emit('success', form)
        }
      } else {
        if (
          this.copyform.status == '0' &&
          this.copyform.business_name == form.business_name &&
          this.copyform.business_website == form.business_website &&
          this.copyform.name == form.name &&
          this.copyform.spec == form.spec &&
          this.copyform.price == form.price &&
          this.copyform.discounted_price == form.discounted_price &&
          this.copyform.picture == form.picture &&
          this.copyform.website == form.website &&
          this.copyform.currency == form.currency
        ) {
          this.copyform.currency = form.currency
          this.copyform.currency_symbol = form.currency_symbol
          this.copyform.number = Number(this.copyform.number) + 1
          let res = await api.post(this, {
            path: 'cart.php',
            api: 'update',
            data: [this.copyform],
            loading: 'loading'
          })
          if (res.body.status == 'ok') {
            this.$emit('success', form)
          }
        } else {
          let res = await api.post(this, {
            path: 'cart.php',
            api: 'add',
            data: [form],
            loading: 'loading'
          })
          if (res.body.status == 'ok') {
            this.$emit('success', form)
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/cart/AddProducts.vue